import { Component, Inject, ViewEncapsulation } from '@angular/core';
import {
  MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA,
  MatLegacySnackBarRef as MatSnackBarRef,
} from '@angular/material/legacy-snack-bar';

export interface ReportSentSnackbarData {
  email?: string;
}

@Component({
  selector: 'app-report-sent-snackbar',
  templateUrl: './report-sent-snackbar.component.html',
  styleUrls: ['./report-sent-snackbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ReportSentSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: ReportSentSnackbarData,
    public snackBarRef: MatSnackBarRef<ReportSentSnackbarComponent>,
  ) {}
}
